var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid",class:[("grid--" + _vm.col), {'grid--indent': _vm.indent}]},_vm._l((_vm.arr),function(item){return _c('div',{key:item,staticClass:"grid__item"},[_vm._t(("item-" + item))],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }